import { apiClient } from "../api/AllApi";

/** Logged-in user info stored at login (see shared/api/AllApi.js / usePermissions.js). */
export function getSessionUser() {
  try {
    return JSON.parse(localStorage.getItem("sessionUser")) || {};
  } catch {
    return {};
  }
}

/** { name, phone } for the current user — used to stamp "printed by" on documents. */
export function getPrintedByInfo() {
  const u = getSessionUser();
  return { name: u.name || "", phone: u.phone || "" };
}

function clearSessionAndGoToLogin() {
  localStorage.removeItem("sessionToken");
  localStorage.removeItem("sessionUser");
  localStorage.removeItem("sessionPermissions");
  window.location.href = "/";
}

let heartbeatTimer = null;

/**
 * Poll `/profile` every 2s while a session token is stored. If the token was
 * revoked server-side (forced logout from another device, admin action, expiry),
 * the very next tick sees the 401 and sends the user straight to the login page
 * instead of waiting for them to trigger some other API call first.
 */
export function startSessionHeartbeat() {
  if (heartbeatTimer) return;

  const tick = async () => {
    const token = localStorage.getItem("sessionToken");
    if (!token) return;
    try {
      await apiClient.get("/profile", {
        skipAuthRedirect: true,
        skipShiftCheck: true,
        skipTimeoutToast: true,
        skipForbiddenToast: true,
      });
    } catch (error) {
      const status = error?.response?.status;
      if (status === 401) {
        clearSessionAndGoToLogin();
      }
      // Network hiccups / timeouts aren't a reason to log the user out.
    }
  };

  heartbeatTimer = setInterval(tick, 2000);
}
